<template>
  <div class="row justify-content-center">
  <div class="col-lg-9 notedGrid page">
    <div class="note-grid col-sm-12 col-md-9 col-lg-9">
      <div class="header">
        <h1 class="title">Notes</h1>
        <span id="patientNote" class="coltext msgiconbtn"><img title="Write a note"
        src="https://cdn4.iconfinder.com/data/icons/eon-ecommerce-i-1/32/message_letter_email_mail_send_envelope-512.png"
        width="40" height="40" @click="showNote(patient.id)" /></span>
      </div>
      <note-popup :type="'Nursing'" class="note__popup" :patient="patient" :id="'note__popup' + patient.id" style="display: none" />
      <template v-if="notes">
        <div v-for="(metaItem,metaIndex) in meta" :key="metaKey(metaIndex)" class="row gx-0 baserow justify-content-start">
          <dropdown-header :open="metaItem.open" :target="`#${metaTargetId(metaIndex)}`">
            <template v-slot:header><div class="col-1">{{ metaItem.yearmonth }}</div></template>
            <template v-slot:dropdown>
              <div :id="metaTargetId(metaIndex)" :class="metaClass(metaItem)"
                    @[`shown.bs.collapse`].stop='metaUpdateOpen(metaIndex,true)'
                    @[`hidden.bs.collapse`].stop='metaUpdateOpen(metaIndex,false)'>
                <div v-for="n in metaItem.size" :key="noteKey(metaItem,n)" class="row gx-0 baserow">
                  <dropdown-header :open="metaNote(metaItem,n).open" :target="`#${noteTargetId(metaIndex,n)}`">
                    <template v-slot:header>
                      <div class="col-1 offset-1">
                        <div>From</div>
                        <div>To</div>
                      </div>
                      <div class="col-2">
                        <div>{{ noteFrom(metaItem,n) }}</div>
                        <div>{{ noteTo(metaItem,n) }}</div>
                      </div>
                      <div class="col-3">{{ noteName(metaItem,n) }}</div>
                      <div class="col-3">{{ noteType(metaItem,n) }}</div>
                    </template>
                    <template v-slot:dropdown>
                      <div :id="noteTargetId(metaIndex,n)" :class="noteClass(metaItem,n)" 
                            @[`shown.bs.collapse`].stop='noteUpdateOpen(metaItem,n,true)'
                            @[`hidden.bs.collapse`].stop='noteUpdateOpen(metaItem,n,false)'>
                        <span class="coltext" v-html="metaNote(metaItem,n).pnotes"/>
                      </div>
                    </template>
                  </dropdown-header>
                </div>
              </div>
            </template>
          </dropdown-header>
        </div>
      </template>
    </div>
  </div>
  </div>
</template>

<script>
import { CURR_API, OTHER_API } from '@/constants/apis'
import { mapGetters, mapActions } from "vuex";
import axios from 'axios'
import TogglableCaretHeader from '@/components/includes/TogglableCaretHeader';
import DropdownHeader from '@/components/includes/DropdownHeader';
import NotePopup from "@/components/private-layouts/NotePopup.vue"
import { buffer } from 'd3-fetch';
 
export default {
  name: "NotesPage",
  components: {
    'dropdown-header' : DropdownHeader,
    "note-popup": NotePopup,
  },
  data() {
    return {
        notes: [],
        meta: []
    };
  },
  async mounted() {
      this.getNote()
  },
  computed: {
    ...mapGetters("login", {
      allData: "getAllData",
    }),
    patient: function() {
      return this.allData.patient
    },
  },               
  methods: {
    showNote(id) {
      let note = document.getElementById('note__popup' + id)
      note.style.display = 'flex'
    },
    metaNote(metaItem,n) {
      return this.notes[metaItem.base+n-1];
    },
    metaClass(metaItem) {
      return 'collapse row gx-0 ' + (metaItem.open ? 'show' : '');
    },
    noteClass(metaItem,n) {
      let note = this.metaNote(metaItem,n);
      return 'collapse ' + (note.open ? 'show' : '');
    },
    noteTargetId(metaIndex,n) {
      return 'note-target-'+metaIndex+'-'+(this.meta[metaIndex].base + n - 1);
    },
    metaTargetId(metaIndex) {
      return 'meta-target-' + metaIndex;
    },
    metaKey(metaIndex) {
      return 'meta-key-' + metaIndex;
    },
    noteKey(metaItem,n) {
      let note = this.metaNote(metaItem,n);
      return 'note-' + note.pid;
    },
    metaUpdateOpen(metaIndex,value) {
      this.$set(this.meta[metaIndex],'open',value);
    },
    noteUpdateOpen(metaItem,n,value) {
      let note = this.metaNote(metaItem,n);
      this.$set(note,'open',value);
    },
    noteFrom(metaItem,n) {
      let note = this.metaNote(metaItem,n);
      return this.noteTimestamp(note.startDt,note.startTime);
    },
    noteTo(metaItem,n) {
      let note = this.metaNote(metaItem,n);
      return this.noteTimestamp(note.endDt,note.endTime);
    },
    noteName(metaItem,n) {
      let note = this.metaNote(metaItem,n);
      return note.name || note.patientId;
    },
    noteType(metaItem,n){
      let note = this.metaNote(metaItem,n)
      return {
        'Vitals':'Vitals',
        'Nursing': 'Nursing',
        '9945X': 'Vitals CPT (9945X)',
        '9898X': 'Therapeutic CPT (9898x)'}[note.type]
    },
    noteTimestamp(dt,tm) {
      let x = new Date(Date.parse(dt));
      x = (x.getUTCMonth()+1).toString().padStart(2,'0') + '-' +
          x.getUTCDate().toString().padStart(2,'0') + ' ';
      let y = new Date(Date.parse('1901-01-01 ' + tm));

      y = x + y.getUTCHours().toString().padStart(2,'0') + ':' +
          y.getUTCMinutes().toString().padStart(2,'0');
      return y;
    },
    async getNote() {
        let content = {
            "Note": {
                "API_Meth": "GetAllNotes",
                "patientID": this.allData.patient.externId
            }
        }
        await axios.post(CURR_API + "/tswebhook.php", content, {headers: {'Content-Type': 'application/json;'}})
        .then((res) => {
            if (res.data.data) {
                let i;
                this.notes = res.data.data;
                for(i in this.notes)
                {
                  this.$set(this.notes[i],'open',false);
                }
                this.meta = [];
                for(i in res.data.meta)
                {
                  const src = res.data.meta[i];

                  let temp = {
                    base : Number(src.base),
                    size : Number(src.size),
                    yearmonth: src.yearmonth,
                    open: false
                  };
                  this.$set(this.meta,i,temp);
                }
                // console.log(this.notes)
            }
            else {
                this.notes = [];
            }
        })
    }
  },
};
</script>
<style scoped lang="scss">
.baserow:nth-child(odd)
{
    background-color:rgba(0,0,0,.02);
}
.baserow:nth-child(even)
{
    background-color:rgba(0,0,0,.04);
}
.header {
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
  color: #0060ff;
}
.title {
  margin-right: 20px;
}
.note-grid {
  margin: 0 auto;
}


</style>

<style lang="scss">
// @import "../../stylesheets/keyon";
</style>
